/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdvertiseState } from "../models/AdvertiseState";
import type { AdvertiseStatus } from "../models/AdvertiseStatus";
import type { AjaxResponseOfAddressDto } from "../models/AjaxResponseOfAddressDto";
import type { AjaxResponseOfBoolean } from "../models/AjaxResponseOfBoolean";
import type { AjaxResponseOfDocumentFileDto } from "../models/AjaxResponseOfDocumentFileDto";
import type { AjaxResponseOfFileDto } from "../models/AjaxResponseOfFileDto";
import type { AjaxResponseOfGetDataForVehicleAdPublish } from "../models/AjaxResponseOfGetDataForVehicleAdPublish";
import type { AjaxResponseOfGetFullVehicleAdForViewDto } from "../models/AjaxResponseOfGetFullVehicleAdForViewDto";
import type { AjaxResponseOfGetVehicleAdForEditOutput } from "../models/AjaxResponseOfGetVehicleAdForEditOutput";
import type { AjaxResponseOfGetVehicleAdForLp } from "../models/AjaxResponseOfGetVehicleAdForLp";
import type { AjaxResponseOfGetVehicleAdForViewDto } from "../models/AjaxResponseOfGetVehicleAdForViewDto";
import type { AjaxResponseOfGetVehicleDetailsWebPublicOutput } from "../models/AjaxResponseOfGetVehicleDetailsWebPublicOutput";
import type { AjaxResponseOfListOfAdditionalDto } from "../models/AjaxResponseOfListOfAdditionalDto";
import type { AjaxResponseOfListOfComboboxItemDto } from "../models/AjaxResponseOfListOfComboboxItemDto";
import type { AjaxResponseOfListOfUserVendorDto } from "../models/AjaxResponseOfListOfUserVendorDto";
import type { AjaxResponseOfPagedResultDtoOfGetVehicleAdForViewDto } from "../models/AjaxResponseOfPagedResultDtoOfGetVehicleAdForViewDto";
import type { AjaxResponseOfPagedResultDtoOfVehicleAdPortalsDto } from "../models/AjaxResponseOfPagedResultDtoOfVehicleAdPortalsDto";
import type { AjaxResponseOfString } from "../models/AjaxResponseOfString";
import type { AjaxResponseOfVehicleAdDto } from "../models/AjaxResponseOfVehicleAdDto";
import type { AjaxResponseOfWebmotorsMotorcycleAttributes } from "../models/AjaxResponseOfWebmotorsMotorcycleAttributes";
import type { CreateOrEditVehicleAdDto } from "../models/CreateOrEditVehicleAdDto";
import type { CreateVehicleAdTagsInput } from "../models/CreateVehicleAdTagsInput";
import type { CreateVehicleCopyInput } from "../models/CreateVehicleCopyInput";
import type { EntityDtoOfGuid } from "../models/EntityDtoOfGuid";
import type { GetDataForVehicleAdPublishInput } from "../models/GetDataForVehicleAdPublishInput";
import type { PartialUnpublishInput } from "../models/PartialUnpublishInput";
import type { PublishShippingFromLiveEditingInput } from "../models/PublishShippingFromLiveEditingInput";
import type { PublishShippingInput } from "../models/PublishShippingInput";
import type { VehicleFileUploadInput } from "../models/VehicleFileUploadInput";
import type { VehicleImageUpload } from "../models/VehicleImageUpload";
import type { VehicleInput } from "../models/VehicleInput";
import type { VehicleType } from "../models/VehicleType";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehicleAdsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public copy({
    requestBody,
  }: {
    requestBody?: CreateVehicleCopyInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/copy",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfGetDataForVehicleAdPublish
   * @throws ApiError
   */
  public allPortalsForVehicleAdPublish({
    requestBody,
  }: {
    requestBody?: GetDataForVehicleAdPublishInput;
  }): CancelablePromise<AjaxResponseOfGetDataForVehicleAdPublish> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/all-portals-for-vehicle-ad-publish",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfListOfAdditionalDto
   * @throws ApiError
   */
  public returnAllVehicleAdAdditionalInfo(): CancelablePromise<AjaxResponseOfListOfAdditionalDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/all-additional-info",
    });
  }

  /**
   * @returns AjaxResponseOfBoolean
   * @throws ApiError
   */
  public checkAreJobsDone({
    jobIds,
  }: {
    jobIds?: string;
  }): CancelablePromise<AjaxResponseOfBoolean> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/check-are-jobs-done",
      query: {
        jobIds: jobIds,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEdit({
    requestBody,
  }: {
    requestBody?: CreateOrEditVehicleAdDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/create-or-edit",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createVehicleAdTag({
    requestBody,
  }: {
    requestBody?: CreateVehicleAdTagsInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/create-vehicle-ad-tag",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id?: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vehicle-ads",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfGetVehicleAdForViewDto
   * @throws ApiError
   */
  public getAll({
    filter,
    plateFilter,
    maxModelYearFilter,
    minModelYearFilter,
    makeFilter,
    modelFilter,
    vehicleCategoryFilter,
    vehicleTypeFilter,
    advertiseStateFilter,
    vendorId,
    onlyPendding,
    onlyRequiresAttention,
    onlyPartiallyPublished,
    tagsFilter,
    vehicleWithoutTypeMotorcycle,
    vehicleWithoutTypeCar,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    plateFilter?: string;
    maxModelYearFilter?: number;
    minModelYearFilter?: number;
    makeFilter?: string;
    modelFilter?: string;
    vehicleCategoryFilter?: string;
    vehicleTypeFilter?: VehicleType;
    advertiseStateFilter?: AdvertiseState;
    vendorId?: number;
    onlyPendding?: boolean;
    onlyRequiresAttention?: boolean;
    onlyPartiallyPublished?: boolean;
    tagsFilter?: Array<number>;
    vehicleWithoutTypeMotorcycle?: boolean;
    vehicleWithoutTypeCar?: boolean;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfGetVehicleAdForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads",
      query: {
        filter: filter,
        plateFilter: plateFilter,
        maxModelYearFilter: maxModelYearFilter,
        minModelYearFilter: minModelYearFilter,
        makeFilter: makeFilter,
        modelFilter: modelFilter,
        vehicleCategoryFilter: vehicleCategoryFilter,
        vehicleTypeFilter: vehicleTypeFilter,
        advertiseStateFilter: advertiseStateFilter,
        vendorId: vendorId,
        onlyPendding: onlyPendding,
        onlyRequiresAttention: onlyRequiresAttention,
        onlyPartiallyPublished: onlyPartiallyPublished,
        tagsFilter: tagsFilter,
        vehicleWithoutTypeMotorcycle: vehicleWithoutTypeMotorcycle,
        vehicleWithoutTypeCar: vehicleWithoutTypeCar,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteAndUnpublish({
    requestBody,
  }: {
    requestBody?: VehicleInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/delete-and-unpublish",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfVehicleAdDto
   * @throws ApiError
   */
  public findVehicleAd({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfVehicleAdDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/find-vehicle-ad",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfUserVendorDto
   * @throws ApiError
   */
  public getAllAssignedVendorsComboboxItems(): CancelablePromise<AjaxResponseOfListOfUserVendorDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-all-assigned-vendors-combobox-items",
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfVehicleAdPortalsDto
   * @throws ApiError
   */
  public getAllVehicleAdPortals({
    filter,
    vehicleAdId,
    statusInternal,
    onlyPenddingPortals,
    vehicleType,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    vehicleAdId?: string;
    statusInternal?: Array<AdvertiseStatus>;
    onlyPenddingPortals?: boolean;
    vehicleType?: number;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfVehicleAdPortalsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-all-vehicle-ad-portals",
      query: {
        filter: filter,
        vehicleAdId: vehicleAdId,
        statusInternal: statusInternal,
        onlyPenddingPortals: onlyPenddingPortals,
        vehicleType: vehicleType,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfAddressDto
   * @throws ApiError
   */
  public getCurrentUserDefaultAddress(): CancelablePromise<AjaxResponseOfAddressDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-current-user-default-address",
    });
  }

  /**
   * @returns AjaxResponseOfWebmotorsMotorcycleAttributes
   * @throws ApiError
   */
  public getFullMotorcycleAttributes({
    rscMake,
    rscModel,
    modelYear,
  }: {
    rscMake?: string;
    rscModel?: string;
    modelYear?: number;
  }): CancelablePromise<AjaxResponseOfWebmotorsMotorcycleAttributes> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-motocycle-specifications",
      query: {
        rscMake: rscMake,
        rscModel: rscModel,
        modelYear: modelYear,
      },
    });
  }

  /**
   * @returns AjaxResponseOfString
   * @throws ApiError
   */
  public getExternalLink({
    portalCode,
    vehicleAdId,
  }: {
    portalCode:
      | "WebMotorsPortalName"
      | "AutolinePortalName"
      | "CompreCarPortalName"
      | "FacebookPortalName"
      | "iCarrosPortalName"
      | "MercadoLivrePortalName"
      | "MeuCarroNovoPortalName"
      | "MobiAutoPortalName"
      | "OlxPortalName"
      | "ResourcesPortalName"
      | "MotorMePortalName"
      | "UsadosbrPortalName"
      | "SyncCmsPortalName"
      | "CarroSP"
      | "ChavesNaMao"
      | "Platforms"
      | "SoCarrao"
      | "RepasseAutos"
      | "Youtube"
      | "Cockpit"
      | "NaPistaLeads"
      | "SalaoDoCarro"
      | "CompreCarPortalLeads"
      | "ClickAutos"
      | "NetMotors"
      | "AutoShopping"
      | "ChavesNaMaoPortalLeads"
      | "ClickAutosPortalLeads"
      | "Premium";
    vehicleAdId?: string;
  }): CancelablePromise<AjaxResponseOfString> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-external-link",
      query: {
        vehicleAdId: vehicleAdId,
        portalCode: portalCode,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetFullVehicleAdForViewDto
   * @throws ApiError
   */
  public getFullVehicleAdForView({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfGetFullVehicleAdForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-full-vehicle-ad-for-view",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfComboboxItemDto
   * @throws ApiError
   */
  public getMakesComboboxItems(): CancelablePromise<AjaxResponseOfListOfComboboxItemDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-makes-combobox-items",
    });
  }

  /**
   * @returns AjaxResponseOfGetVehicleDetailsWebPublicOutput
   * @throws ApiError
   */
  public getVehicleAdDetailsForWebPublic({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfGetVehicleDetailsWebPublicOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-vehicle-ad-details-for-web-public",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetVehicleAdForEditOutput
   * @throws ApiError
   */
  public getVehicleAdForEdit({
    id,
    vehicleType,
  }: {
    id?: string;
    vehicleType?: number;
  }): CancelablePromise<AjaxResponseOfGetVehicleAdForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-vehicle-ad-for-edit",
      query: {
        id: id,
        vehicleType: vehicleType,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetVehicleAdForLp
   * @throws ApiError
   */
  public getVehicleAdForLp({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfGetVehicleAdForLp> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-vehicle-ad-for-lp",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetVehicleAdForViewDto
   * @throws ApiError
   */
  public getVehicleAdForView({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfGetVehicleAdForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-vehicle-ad-for-view",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfFileDto
   * @throws ApiError
   */
  public getVehicleAdsToExcel({
    filter,
    plateFilter,
    maxModelYearFilter,
    minModelYearFilter,
    makeFilter,
    modelFilter,
    vehicleCategoryFilter,
    vehicleTypeFilter,
  }: {
    filter?: string;
    plateFilter?: string;
    maxModelYearFilter?: number;
    minModelYearFilter?: number;
    makeFilter?: string;
    modelFilter?: string;
    vehicleCategoryFilter?: string;
    vehicleTypeFilter?: number;
  }): CancelablePromise<AjaxResponseOfFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-ads/get-vehicle-ads-to-excel",
      query: {
        filter: filter,
        plateFilter: plateFilter,
        maxModelYearFilter: maxModelYearFilter,
        minModelYearFilter: minModelYearFilter,
        makeFilter: makeFilter,
        modelFilter: modelFilter,
        vehicleCategoryFilter: vehicleCategoryFilter,
        vehicleTypeFilter: vehicleTypeFilter,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public moveVehicleAdToInventory({
    requestBody,
  }: {
    requestBody?: EntityDtoOfGuid;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/move-vehicle-ad-to-inventory",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public publishShipping({
    requestBody,
  }: {
    requestBody?: PublishShippingInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/publish-shipping",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public publishShippingFromLiveEditing({
    requestBody,
  }: {
    requestBody?: PublishShippingFromLiveEditingInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/publish-shipping-from-live-editing",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public removeVehicleAdTag({
    requestBody,
  }: {
    requestBody?: CreateVehicleAdTagsInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/remove-vehicle-ad-tag",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public unpublishPartial({
    requestBody,
  }: {
    requestBody?: PartialUnpublishInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/unpublish-partial",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public unpublishShipping({
    requestBody,
  }: {
    requestBody?: VehicleInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/unpublish-shipping",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfDocumentFileDto
   * @throws ApiError
   */
  public uploadVehicleAdImage({
    requestBody,
  }: {
    requestBody?: VehicleFileUploadInput;
  }): CancelablePromise<AjaxResponseOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/upload-vehicle-ad-image",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public uploadVehicleImage({
    requestBody,
  }: {
    requestBody?: VehicleImageUpload;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/upload-vehicle-image",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfDocumentFileDto
   * @throws ApiError
   */
  public uploadVehicleAdVideo({
    requestBody,
  }: {
    requestBody?: VehicleFileUploadInput;
  }): CancelablePromise<AjaxResponseOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-ads/upload-vehicle-ad-video",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
